import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TagsService } from "@app/services/tags.service";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { DynamicReportService } from "@reports/_services/dynamicReports.service";
import { providerCreator } from "@services/_services.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { DriverListComponent } from "./driver-list/driver-list.component";
import { DateButtonFilterComponent } from "./filter-bar/date-button-filter/date-button-filter.component";
import { DriverButtonFilterComponent } from "./filter-bar/driver-button-filter/driver-button-filter.component";
import { FilterBarComponent } from "./filter-bar/filter-bar.component";
import { ItemFilterComponent } from "./filter-bar/item-filter/item-filter.component";
import { VehicleTypeButtonFilterComponent } from "./filter-bar/resource-type-button-filter/vehicle-type-button-filter.component";
import { TagButtonFilterComponent } from "./filter-bar/tag-button-filter/tag-button-filter.component";
import { VerticalFilterListComponent } from "./vertical-filter-list/vertical-filter-list.component";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    FilterBarComponent,
    ItemFilterComponent,

    DriverButtonFilterComponent,
    DateButtonFilterComponent,
    TagButtonFilterComponent,

    DriverListComponent,

    VerticalFilterListComponent,
    VehicleTypeButtonFilterComponent,
];

const directives: any[] = [
    //NewResourceFilterBarWrapper,
    //DateResourceFilterWrapper
];

const providers: any[] = [
    providerCreator(DynamicReportService, "dynamicReportService"),
    providerCreator(TagsService, "tagsService")
];

@NgModule({
    providers: providers,
    imports: [
        CommonModule,
        ScrollingModule,
        VeriDirectivesModule,
        PipesModule,
        FormsDirectivesModule,
        CoreDirectivesModule,
        MiscDirectivesModule,
        LayoutDirectivesModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...directives],
    exports: [...publicComponents, ...directives]
})
export class ResourceFiltersDirectivesModule {
    constructor() {
    }
}
